<template>
    <div class="credit-debit-tab">
        <BasePanel>
            <template #content>
                <template v-if="!successful">
                    <div class="amount-to">
                        <h3 class="title title__medium">{{ tokens.newDesign.amountToWithdrawal }}</h3>
                        <div class="inputs-list">
                            <BaseInput v-model="amount" :type="'number'" :title="tokens.newDesign.amount" :placeholder="'0.00'">
                                <template #icon>
                                    <p class="body__large">{{currencySign(activeAccount.currency)}}</p>
                                </template>
                                <template #info>
                                    <p class="body__large">{{ activeAccount.currency }}</p>
                                </template>
                            </BaseInput>
                        </div>
                    </div>

                    <div class="bank-details">
                        <h3 class="title title__medium">{{  tokens.fullScreenWithdrawal.bankDetails }}</h3>
                        <div class="inputs-list">
                            <BaseInput v-if="bankWithdrawalFields.includes('account')" v-model="account" :title="tokens.fullScreenWithdrawal.bankAccount"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('holder')" v-model="holder" :title="tokens.fullScreenWithdrawal.bankHolder"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('iban')" v-model="iban" :title="tokens.fullScreenWithdrawal.bankIban"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('swift')" v-model="swift" :title="tokens.fullScreenWithdrawal.bankSwift"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('recipientAddress')" v-model="recipientAddress" :title="tokens.fullScreenWithdrawal.recipientAddress"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('routingNumber')" v-model="routingNumber" :title="tokens.fullScreenWithdrawal.routingNumber"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('bankBeneficiary')" v-model="bankBeneficiary" :title="tokens.fullScreenWithdrawal.bankBeneficiary"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('bankAddress')" v-model="bankAddress" :title="tokens.fullScreenWithdrawal.bankAddress"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('bankCode')" v-model="bankCode" :title="tokens.fullScreenWithdrawal.bankCode"/>
                            <BaseInput v-if="bankWithdrawalFields.includes('desc')" v-model="desc" :title="tokens.fullScreenWithdrawal.desc"/>
                        </div>
                    </div>
                   
                    <div class="confirm">
                        <SendWithdrawal
                            :disabled="!amount || !holder || !account"
                            :info="getInfo"
                            @send="showSuccessful()"
                        />
                    </div>
                </template>
                <template v-else>
                    <SuccessfulTab
                        :details="getDetails"
                        @closeSuccessfullTab="closeSuccessfullTab"
                        @showAccounts="showAccounts"
                    />
                </template>
            </template>
        </BasePanel>
    </div>
</template>

<script>
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import SendWithdrawal from "@/new-design/features/Withdrawal/ui/SendWithdrawal.vue"
import {mapGetters} from "vuex"
import SuccessfulTab from "@/new-design/pages/withdrawal/tabs/SuccessfulTab.vue"
import {currencySign} from "@/common/helpers"
import {MODAL, MODAL_FULLSCREEN} from "@/store/mutations.type"
import {BANK_WITHDRAWAL_FIELDS} from "@/common/config";

export default {
    name: "CreditDebitTab",
    components: {SuccessfulTab, SendWithdrawal, BaseInput, BasePanel},
    mounted() {
        this.init()
    },
    data() {
        return {
            amount: null,
            account: "",
            holder: "",
            iban: "",
            swift: "",
            recipientAddress: "",
            routingNumber: "",
            bankBeneficiary: "",
            bankAddress: "",
            bankCode: "",
            desc: "",
            successful: false,
            bankWithdrawalFields: BANK_WITHDRAWAL_FIELDS
        }
    },
    methods: {
        init() {
            this.account =  "";
            this.holder =  "";
            this.iban =  "";
            this.swift =  "";
            this.recipientAddress = "",
            this.routingNumber = "",
            this.bankBeneficiary = "",
            this.bankAddress = "",
            this.bankCode = "",
            this.desc = "",
            this.successful = false
        },
        showSuccessful() {
            this.successful = true
        },
        showAccounts() {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page: 'accounts'
            })
        },
        closeSuccessfullTab() {
            this.init()
            this.successful = false
        },
        currencySign
    },
    computed: {
        ...mapGetters(['activeAccount','tokens']),
        getInfo() {
            return {
                method: 'bank',
                amount: this.amount,
                account: this.account,
                holder: this.holder,
                iban: this.iban,
                recipientAddress: this.recipientAddress,
                routingNumber: this.routingNumber,
                bankBeneficiary: this.bankBeneficiary,
                bankAddress: this.bankAddress,
                bankCode: this.bankCode,
                desc: this.desc,
                swift: this.swift,
                activeAccount: this.activeAccount,
            }
        },
        getDetails() {
            return [
                {
                    title: 'Amount withdrawn',
                    value: currencySign(this.activeAccount.currency) + ' ' + this.amount,
                },
                {
                    title: 'Currency',
                    value: this.activeAccount.currency
                },
                {
                    title: 'Time',
                    value: this.formattedWithdrawalTime
                },
                {
                    title: 'Transaction status',
                    value: 'Processing'
                },
            ]
        },
        formattedWithdrawalTime() {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
            return new Date().toLocaleString('en-GB', options).replace(',', '')
        },
    }
}
</script>


<style scoped>
.title {
    color: var(--System-OnSurface);
    margin-bottom: 16px;
}

.amount-to,
.card-details {
    margin-bottom: 16px;
}

.cards-list {
    display: flex;
    align-items: center;
    gap: 4px;
}

.inputs-list {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.confirm {
    margin-top: 24px;
    width: 100%;
    text-align: right;
}
</style>
